<script setup>
const { $_ } = useNuxtApp()
const model = defineModel()
</script>
<template>
    <div class="whole">
        <div class="wrap">
            <Idea />
            <h2 class="mobileTitle">
                {{ $_('guide.mobile_title', 'Nainstalujte si aplikaci Portál občana do svého mobilu. Jak na to?') }}
            </h2>
            <h2 class="desktopTitle">
                {{ $_('guide.desktop_title', 'Nainstalujte si aplikaci Portál občana na plochu. Jak na to?') }}
            </h2>
        </div>
        <GuideContent v-on:close="()=>model = false" />
    </div>
</template>
<style scoped>
h2 {
    font-weight: 700;
}

.whole {
    container-type: inline-size;
}

.wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 18px;
}

@media screen and (max-width: 1280px) {
    .desktopTitle {
        display: none;
    }
}

@media screen and (min-width: 1280px) {
    .mobileTitle {
        display: none;
    }
}

@container (max-width: 600px) {
    :deep(.desktopContainer) {
        flex-direction: column;
    }

    :deep(.desktopContainer .wholeWrap) {
        flex-direction: row;
        flex-wrap: nowrap;
    }
}
</style>
